import { Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CLIENT_AREA_URL, NAV_ITEMS } from '../nav-items';

/** Logo + menu desktop (submenus no hover/foco) + botão do menu mobile. */
@Component({
  selector: 'app-header-main',
  imports: [RouterLink],
  templateUrl: './header-main.html',
  styleUrl: './header-main.scss',
})
export class HeaderMain {
  /** Estado do menu mobile, só para o `aria-expanded` do botão. */
  readonly menuOpen = input(false);
  readonly menuToggle = output<void>();

  protected readonly items = NAV_ITEMS;
  protected readonly clientAreaUrl = CLIENT_AREA_URL;
}
